var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zl_login" },
    [
      _c(
        "el-button",
        { staticClass: "notice_btn", on: { click: _vm.noticeBtn } },
        [_vm._v("通知公告")]
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "teach_home_logo",
        attrs: { src: require("../../static/images/newLoginPage/logo.png") }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "teach_home_pic",
        attrs: {
          src: require("../../static/images/newLoginPage/homepagePic.png")
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "teach_home_title" }, [
        _vm._v("实训教学综合服务平台")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "teach_home_msg" }, [
        _vm._v(
          "\n    基于中联集团产业集群服务全国百万企业实践，创新智慧财经职业教育与培训体系，共建高水平专业化产教融合实训基地技术创新平台\n  "
        )
      ]),
      _vm._v(" "),
      _vm.loginStatus === 0
        ? _c(
            "div",
            { staticClass: "login_window" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "loginForm",
                  attrs: { model: _vm.loginForm, rules: _vm.rules }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "username" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入用户名",
                          type: "text",
                          autocomplete: "off",
                          "prefix-icon": "el-icon-user"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitForm("loginForm")
                          }
                        },
                        model: {
                          value: _vm.loginForm.username,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.loginForm,
                              "username",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "loginForm.username"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入密码",
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          maxLength: "18"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitForm("loginForm")
                          }
                        },
                        model: {
                          value: _vm.loginForm.password,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.loginForm,
                              "password",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "loginForm.password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "8px" },
                      attrs: { prop: "validCode" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入验证码",
                          type: "text",
                          autocomplete: "off",
                          "prefix-icon": "el-icon-key",
                          maxLength: "10"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitForm("loginForm")
                          }
                        },
                        model: {
                          value: _vm.loginForm.validCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.loginForm,
                              "validCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "loginForm.validCode"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "verificationCode_btn",
                          on: { click: _vm.getCode }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.imgurl, alt: "加载失败" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        model: {
                          value: _vm.loginForm.uuid,
                          callback: function($$v) {
                            _vm.$set(_vm.loginForm, "uuid", $$v)
                          },
                          expression: "loginForm.uuid"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "forget" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.forgetPassword("loginForm")
                          }
                        }
                      },
                      [_vm._v("忘记密码")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "login_btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("loginForm")
                        }
                      }
                    },
                    [_vm._v("立即登录")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.loginStatus === 1
        ? _c(
            "div",
            { staticClass: "login_window" },
            [
              _c("div", { staticClass: "password_title" }, [
                _c("h1", [_vm._v("修改密码")]),
                _vm._v(" "),
                _vm.passwordLongTime
                  ? _c("p", [
                      _vm._v(
                        "您的密码长时间未更新，为了您的账号安全请修改密码！"
                      )
                    ])
                  : _c("p", [
                      _vm._v("您的密码过于简单，为了您的账号安全请修改密码！")
                    ])
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "passwordEditForm",
                  attrs: {
                    model: _vm.passwordEditForm,
                    rules: _vm.passwordEditRules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "newpassword" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入新密码",
                          type: "password",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          autocomplete: "off"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitPasswordEdit("passwordEditForm")
                          }
                        },
                        model: {
                          value: _vm.passwordEditForm.newpassword,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.passwordEditForm,
                              "newpassword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "passwordEditForm.newpassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "margin-bottom": "8px",
                        "margin-top": "30px"
                      },
                      attrs: { prop: "newrepeatpassword" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "重复新密码",
                          type: "password",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          autocomplete: "off"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitPasswordEdit("passwordEditForm")
                          }
                        },
                        model: {
                          value: _vm.passwordEditForm.newrepeatpassword,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.passwordEditForm,
                              "newrepeatpassword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "passwordEditForm.newrepeatpassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "flex-end"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "login_btn",
                          staticStyle: { width: "200px" },
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitPasswordEdit("passwordEditForm")
                            }
                          }
                        },
                        [_vm._v("提        交")]
                      ),
                      _vm._v(" "),
                      _vm.passwordLongTime
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.getLoginName()
                                }
                              }
                            },
                            [_vm._v("跳过")]
                          )
                        : _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.cancelEdit("passwordEditForm")
                                }
                              }
                            },
                            [_vm._v("返回")]
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.loginStatus === 2
        ? _c(
            "div",
            { staticClass: "login_window" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "bindingPhoneForm",
                  attrs: {
                    model: _vm.bindingPhoneForm,
                    rules: _vm.bindingPhoneRules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "moblie" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入要绑定的手机号",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-user",
                          maxLength: "11"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        model: {
                          value: _vm.bindingPhoneForm.moblie,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.bindingPhoneForm,
                              "moblie",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "bindingPhoneForm.moblie"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "phonecode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入验证码",
                          type: "text",
                          autocomplete: "off",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-key",
                          maxLength: "10"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        model: {
                          value: _vm.bindingPhoneForm.phonecode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.bindingPhoneForm,
                              "phonecode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "bindingPhoneForm.phonecode"
                        }
                      }),
                      _vm._v(" "),
                      _vm.showCode
                        ? _c(
                            "el-button",
                            {
                              staticClass: "code-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.sendMessage("bindingPhoneForm")
                                }
                              }
                            },
                            [_vm._v("获取验证码")]
                          )
                        : _c(
                            "el-button",
                            {
                              staticClass: "code-btn",
                              attrs: { type: "primary", disabled: "" }
                            },
                            [_vm._v(" " + _vm._s(_vm.count) + "秒 ")]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: { prop: "newpassword" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入新密码",
                          type: "password",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          autocomplete: "off"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        model: {
                          value: _vm.bindingPhoneForm.newpassword,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.bindingPhoneForm,
                              "newpassword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "bindingPhoneForm.newpassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "8px" },
                      attrs: { prop: "newrepeatpassword" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "重复新密码",
                          type: "password",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          autocomplete: "off"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        model: {
                          value: _vm.bindingPhoneForm.newrepeatpassword,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.bindingPhoneForm,
                              "newrepeatpassword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "bindingPhoneForm.newrepeatpassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "flex-end"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "login_btn",
                          staticStyle: { width: "200px" },
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitBindingForm("bindingPhoneForm")
                            }
                          }
                        },
                        [_vm._v("确       定")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.cancelEdit("bindingPhoneForm")
                            }
                          }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.loginStatus === 3
        ? _c(
            "div",
            { staticClass: "login_window" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "retrieveForm",
                  attrs: { model: _vm.retrieveForm, rules: _vm.retrieveRules }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "moblie" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "注册手机号",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-user",
                          maxLength: "20"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitRetrieveForm("retrieveForm")
                          }
                        },
                        model: {
                          value: _vm.retrieveForm.moblie,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.retrieveForm,
                              "moblie",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "retrieveForm.moblie"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "phonecode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入验证码",
                          type: "text",
                          autocomplete: "off",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-key",
                          maxLength: "10"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitRetrieveForm("retrieveForm")
                          }
                        },
                        model: {
                          value: _vm.retrieveForm.phonecode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.retrieveForm,
                              "phonecode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "retrieveForm.phonecode"
                        }
                      }),
                      _vm._v(" "),
                      _vm.showCode
                        ? _c(
                            "el-button",
                            {
                              staticClass: "code-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.getPhoneCode(
                                    "retrieveForm",
                                    _vm.retrieveForm
                                  )
                                }
                              }
                            },
                            [_vm._v("\n          获取验证码\n        ")]
                          )
                        : _c(
                            "el-button",
                            {
                              staticClass: "code-btn",
                              attrs: { type: "primary", disabled: "" }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.count) +
                                  "秒\n        "
                              )
                            ]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "newpassword" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入新密码",
                          type: "password",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          autocomplete: "off"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitRetrieveForm("retrieveForm")
                          }
                        },
                        model: {
                          value: _vm.retrieveForm.newpassword,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.retrieveForm,
                              "newpassword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "retrieveForm.newpassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "margin-bottom": "8px",
                        "margin-top": "28px"
                      },
                      attrs: { prop: "newrepeatpassword" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "重复新密码",
                          type: "password",
                          readonly: _vm.readonlyInput,
                          "prefix-icon": "el-icon-lock",
                          "show-password": "",
                          autocomplete: "off"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.cancelReadOnly()
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitRetrieveForm("retrieveForm")
                          }
                        },
                        model: {
                          value: _vm.retrieveForm.newrepeatpassword,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.retrieveForm,
                              "newrepeatpassword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "retrieveForm.newrepeatpassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "forget" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.cancelEdit("retrieveForm")
                          }
                        }
                      },
                      [_vm._v("返回登录")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "login_btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitRetrieveForm("retrieveForm")
                        }
                      }
                    },
                    [_vm._v("提   交")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "teach_home_footer" }, [
        _c("p", [_vm._v("技术支持：中联集团教育科技有限公司")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "jump" },
          [
            _vm._v("\n      友情链接：\n      "),
            _c(
              "el-link",
              {
                attrs: { type: "danger", underline: false },
                on: {
                  click: function($event) {
                    return _vm.goUrl("https://china-united.cn/")
                  }
                }
              },
              [_vm._v("中联集团")]
            ),
            _vm._v(" "),
            _c(
              "el-link",
              {
                attrs: { type: "danger", underline: false },
                on: {
                  click: function($event) {
                    return _vm.goUrl("https://www.lhrj.cn/")
                  }
                }
              },
              [_vm._v("领航人杰")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("renew-dialog", {
        attrs: { showModalconfirm: _vm.outerVisible },
        on: {
          onclickCancel: _vm.onclickCancel,
          innerclickConfirm: _vm.innerclickConfirm
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "password_title" }, [
      _c("h1", [_vm._v("Welcome欢迎登录")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "password_title" }, [
      _c("h1", [_vm._v("完善个人信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "password_title" }, [
      _c("h1", [_vm._v("找回密码")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26084dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26084dc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = null
// module chunks = 